export default __webpack_public_path__ + "static/media/facebook-logo.3e55720e.svg";